import { mergeMap, switchMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { makeGridGetRowsResponse } from '@cbridge-tools/default-data-grid';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { SymbolClientAction } from '../symbolClient.action';
import { ClientSymbolFilter } from '../symbolClient.interface';
import { SymbolClientTranslator } from '../symbolClient.translator';

type IDependencies = IClientApiDependencySegment;

export const loadSymbolClientListEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(SymbolClientAction.loadListFromNode.started),
  switchMap((params) => {
    const { resolve, reject, filter, sort, ...payload } = params;
    return dependencies.api.getNodeClientSymbolList({
      ...payload,
      includeUnmapped: SymbolClientTranslator.toApiIncludesUnmapped(filter),
      sort: SymbolClientTranslator.toApiSort(sort),
    }).pipe(
      mergeMap((response) => {
        const { symbols, totalCount, filteredCount, unmappedCount } = response;

        const items = symbols.map(SymbolClientTranslator.fromApiNode);
        const rowCount = filter === ClientSymbolFilter.Unmapped
          ? filteredCount + unmappedCount
          : filteredCount;
        resolve?.(makeGridGetRowsResponse(items, rowCount));

        return [
          SymbolClientAction.loadListFromNode.done({ params, result: { items, totalCount, filteredCount, unmappedCount } }),
        ];
      }),
      catchApiError((error) => {
        // a rejected getRows promise leaves the grid in skeleton state forever;
        // settle it with an empty page so the failure overlay can render
        resolve?.(makeGridGetRowsResponse([], 0));
        return [
          SymbolClientAction.loadListFromNode.failed({ params, error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
